import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';

interface FolderDetailsModalProps {
  coverPictureFileUrl: string;
  description: string;
  name: string;
  onCloseModal: () => void;
  title: string;
}

const FolderDetailsModal = ({
  coverPictureFileUrl,
  description,
  name,
  onCloseModal,
  title,
}: FolderDetailsModalProps) => (
  <ModalWithTemplate
    onCloseModal={onCloseModal}
    header={title}
    screenReadersCloseButtonText={s__(
      'Accessibility|Close the preview window of %{name}',
    ).i__({
      name,
    })}
  >
    <WrapperContent>
      {coverPictureFileUrl && (
        <WrapperPicture>
          <Picture
            $source={coverPictureFileUrl}
            data-testid="cover-picture-folder"
          />
        </WrapperPicture>
      )}
      <Box font="h4-semibold" mb={1}>
        {__('Description')}
      </Box>
      <Box
        font="body-regular-asphalt"
        pr={{ l: 93 }}
        style={{
          whiteSpace: 'pre-wrap',
        }}
      >
        {description}
      </Box>
    </WrapperContent>
  </ModalWithTemplate>
);

export default FolderDetailsModal;

const WrapperContent = styled(Box).attrs({
  width: '100%',
  flexDirection: 'column',
})``;

const WrapperPicture = styled(Box).attrs({
  height: { _: 91, m: 131 },
  width: { _: 200, l: 240 },
  mb: 6,
})``;

const Picture = styled(Box).attrs({
  width: '100%',
  height: '100%',
})<{ $source: string }>`
  border-radius: 3px;
  ${({ $source }) =>
    $source &&
    css`
      background-image: url('${$source}');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    `}
`;
